import { Capacitor } from "@capacitor/core";

/**
 * Open external URL — wrapper que isola web/native open behavior.
 *
 * DOIS modos:
 *
 * 1. Default (OAuth redirects — Strava, Apple, Google, wa.me deeplink):
 *    window.location.href, navegação de página inteira. O fluxo VOLTA por
 *    redirect/callback, então sair do SPA é parte do desenho. Não mudar sem
 *    revisar cada caller de OAuth.
 *
 * 2. `newTab: true` (site externo SEM callback — ex.: metaperson.avatarsdk.com):
 *    o usuário precisa continuar com o app aberto para voltar e concluir o
 *    fluxo aqui. Nativo → browser in-app do Capacitor (@capacitor/browser,
 *    fechável, app segue vivo embaixo). Web → nova aba com noopener; popup
 *    bloqueado cai para navegação plena (melhor que não abrir nada).
 *
 * Use APENAS pra navegação pra origens externas. NÃO usar pra navegação
 * interna React Router.
 */
export interface PlatformOpenOptions {
  newTab?: boolean;
}

export function platformOpen(url: string, opts: PlatformOpenOptions = {}): void {
  if (opts.newTab) {
    if (Capacitor.isNativePlatform()) {
      import("@capacitor/browser")
        .then(({ Browser }) => Browser.open({ url }))
        .catch((err) => {
          console.warn("[platformOpen] Capacitor Browser failed, falling back:", err);
          window.location.href = url;
        });
      return;
    }
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win) {
      console.warn("[platformOpen] popup blocked, falling back to full navigation");
      window.location.href = url;
    }
    return;
  }
  window.location.href = url;
}
